import { useEffect, useRef } from "react";
import { usePathname } from '#app/lib/hooks/router-compat';

export function usePathnameChange(
  callback: (next: string, prev: string) => void,
) {
  const pathname = usePathname();
  const prev = useRef(pathname);
  const cb = useRef(callback);
  cb.current = callback;

  useEffect(() => {
    if (prev.current !== pathname) {
      const previous = prev.current;
      prev.current = pathname;
      cb.current(pathname, previous);
    }
  }, [pathname]);
}
